import _ from 'lodash';
import { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap-old';
import { Controller } from 'react-hook-form';
import classNames from 'classnames';
import ErrorMesssage from 'v2/common/components/ErrorMessage/index';
import { POSITION_VALUE_TYPES } from 'v2/common/constants/index';
import { onRegexOnlyNumber } from 'common/stringUtils/toPositiveNumberString';

const { Lot, Amount } = POSITION_VALUE_TYPES;

const propTypes = {
  quantityValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  quantityType: PropTypes.string,
  isEquity: PropTypes.bool,
  onChangeQuantity: PropTypes.func.isRequired,
  label: PropTypes.string,
  control: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
};
const defaultProps = {
  label: 'Lot',
  isEquity: false,
  quantityType: Lot,
  quantityValue: 1,
};

const Quantity = ({
  onChangeQuantity, label, control, errors, isEquity, quantityValue, quantityType
}) => {
  const options = [
    { name: Amount, tag: 'Amount', isShow: true },
    { name: Lot, tag: isEquity ? 'Qty' : 'Lot', isShow: true }
  ];

  const [quantityName] = useState(_.uniqueId('optionsQuantity-'));
  const type = quantityType || (isEquity ? Amount : Lot);
  const inputBoxStyle = classNames('form-control form-control-sm', { 'is-invalid': !!errors[quantityName] });

  useEffect(() => {
    if (!isEquity) {
      onChangeQuantity({ type: Lot, value: quantityValue });
    }
  }, [isEquity]);

  const validator = {
    validate: (value) => {
      if (!value) {
        return `${label} should be included`;
      }

      return true;
    }
  };

  return (
    <div className="total-lot">
      <div className="lot-container d-flex input-group overall-stops">
        {isEquity && (
        <select
          value={type}
          onChange={(event) => onChangeQuantity({ type: event.target.value, value: quantityValue })}
        >
          {_.map(options, ({ name, tag, isShow }, idx) => (
            isShow ? <option value={name} key={idx}>{tag}</option> : null
          ))}
        </select>
        )}
        <Controller
          render={({ onChange, ref, name }) => (
            <Form.Control
              type="text"
              ref={ref}
              className={inputBoxStyle}
              name={name}
              autoComplete="off"
              value={quantityValue === undefined ? '' : quantityValue.toString()}
              min={1}
              onChange={(event) => {
                onChangeQuantity({ type, value: onRegexOnlyNumber(event.target.value) });
                onChange(onRegexOnlyNumber(event.target.value));
              }}
            />
          )}
          name={quantityName}
          defaultValue={quantityValue}
          control={control}
          rules={validator}
        />
      </div>
      <ErrorMesssage message={errors[quantityName]?.message || ''} />
    </div>
  );
};

Quantity.propTypes = propTypes;
Quantity.defaultProps = defaultProps;

export default memo(Quantity);
